
export default {
  name: "pdv-card-total",
  props: {
    valor: {
      default: 0
    }
  }
};
